import React from "react";

export const ProductInfo = () => {
  const [rows, setRows] = React.useState([]);
  const data = {
    release: (
      <div>
        US: Feb 16 2021 <br /> EU: Feb 19 2021 <br /> ANZ: Feb 27 2021
      </div>
    ),
    platforms: "PS4™, Nintendo Switch™",
    genre: "Action RPG",
    "player(s)": "1",
    audio: "English",
    text: "English",
    publisher: "NIS America, Inc.",
    developer: "YummyYummyTummy, Inc.",
  };

  const makeRows = (datum = data) => {
    let arr = Object.keys(datum);
    setRows(
      arr.map((e, i) => {
        return (
          <div
            key={i}
            className="flex row start"
            style={{ width: "100%", borderBottom: "solid black .5px" }}
          >
            <div
              className="font1 flex row start"
              style={{
                width: "40%",
                textAlign: "left",
                padding: "8px",
                paddingLeft: "16px",
                color: "white",
              }}
            >
              {e.toUpperCase()}
            </div>
            <div
              className="flex row start font3 info-box-text"
              style={{
                width: "60%",
                textAlign: "left",
                padding: "8px",
                paddingLeft: "16px",
              }}
            >
              {datum[e]}
            </div>
          </div>
        );
      })
    );
  };

  React.useEffect(() => {
    makeRows();
  }, []);

  return (
    <section style={{ margin: "64px 0" }} className="flex product-info">
      <div className="info-box flex start">
        <h2
          className="font1"
          style={{
            backgroundColor: "purple",
            color: "white",
            margin: 0,
            width: "100%",
          }}
        >
          Product Info
        </h2>
        <div className="info-contents flex">{rows}</div>
      </div>
    </section>
  );
};
